<div class="reviews-outer">
  <h2 class="trinidad-bold">Rate and describe your stay at {{ (boondock$ | async)?.name }}!</h2>
  <p class="wizard-paragraph _12px">
    Help other guest find the right place for their next trip. As part as CurbNTurf&rsquo;s service we want to make that
    information about the listing is accurate and guests&rsquo; expectations are met.
  </p>
  <div class="w-form">
    <form id="rating-form" name="rating-form" [formGroup]="ratingForm">
      <div class="review-rating-outer" formGroupName="location">
        <h3>How was the location? (Views, noise, access, space, etc.)</h3>
        <curbnturf-rating-rate formControlName="rating"></curbnturf-rating-rate>
        <div class="response-outer accuracy" *ngIf="locationRating > 0 && locationRating < 5">
          <p class="wizard-paragraph">Which listing details led you to rate accuracy less than 5 stars?</p>
          <div class="response-inner" formGroupName="issues">
            <curbnturf-rating-pill label="Too Noisy" formControlName="tooNoisy"> </curbnturf-rating-pill>
            <curbnturf-rating-pill label="Photos" formControlName="photos"> </curbnturf-rating-pill>
            <curbnturf-rating-pill label="Amenities" formControlName="amenities"> </curbnturf-rating-pill>
            <curbnturf-rating-pill label="Address/Location" formControlName="address"> </curbnturf-rating-pill>
          </div>
          <div class="response-details-inner">
            <textarea
              placeholder="Add details..."
              maxlength="5000"
              id="Response"
              name="Response"
              class="w-input"
              formControlName="additionalComments"
            ></textarea>
          </div>
        </div>
      </div>
      <div
        class="w-form-fail"
        style="display: block"
        *ngIf="ratingForm.get('location.rating')?.touched && ratingForm.get('location.rating')?.invalid"
      >
        <div>Please Select a Rating</div>
      </div>
      <div class="review-rating-outer" formGroupName="accuracy">
        <h3>Accuracy</h3>
        <p class="wizard-paragraph">Was everything as it was described?</p>
        <curbnturf-rating-rate formControlName="rating"></curbnturf-rating-rate>
        <div class="response-outer accuracy" *ngIf="accuracyRating > 0 && accuracyRating < 5">
          <p class="wizard-paragraph">Which listing details led you to rate accuracy less than 5 stars?</p>
          <div class="response-inner" formGroupName="issues">
            <curbnturf-rating-pill label="Description" formControlName="description"> </curbnturf-rating-pill>
            <curbnturf-rating-pill label="Photos" formControlName="photos"> </curbnturf-rating-pill>
            <curbnturf-rating-pill label="Amenities" formControlName="amenities"> </curbnturf-rating-pill>
            <curbnturf-rating-pill label="Address/Location" formControlName="addressLocation"> </curbnturf-rating-pill>
          </div>
          <div class="response-details-inner">
            <label for="Accuracy" class="sr-only">Additional Comments</label>
            <textarea
              data-name="Accuracy"
              maxlength="5000"
              id="Accuracy"
              name="Accuracy"
              formControlName="additionalComments"
              placeholder="Additional Comments..."
              class="w-input"
            ></textarea>
          </div>
        </div>
        <div
          class="w-form-fail"
          style="display: block"
          *ngIf="ratingForm.get('accuracy.rating')?.touched && ratingForm.get('accuracy.rating')?.invalid"
        >
          <div>Please Select a Rating</div>
        </div>
      </div>
      <div class="review-rating-outer" formGroupName="overall">
        <h3>How was your overall experience?</h3>
        <curbnturf-rating-rate formControlName="rating"></curbnturf-rating-rate>
        <div class="response-outer check-in" *ngIf="overallRating > 0 && overallRating < 5">
          <p class="wizard-paragraph">Which listing details led you to rate check-in less than 5 stars?</p>
          <div class="response-inner" formGroupName="issues">
            <curbnturf-rating-pill label="Difficult To Find" formControlName="difficultToFind"> </curbnturf-rating-pill>
            <curbnturf-rating-pill label="Incorrect Information" formControlName="incorrectInfo">
            </curbnturf-rating-pill>
            <curbnturf-rating-pill label="Unclear Instructions" formControlName="unclear"> </curbnturf-rating-pill>
          </div>
          <div class="response-details-inner">
            <textarea
              placeholder="Add details..."
              maxlength="5000"
              id="Response-2"
              name="Response-2"
              class="w-input"
              formControlName="additionalComments"
            ></textarea>
          </div>
        </div>
        <div
          class="w-form-fail"
          style="display: block"
          *ngIf="ratingForm.get('overall.rating')?.touched && ratingForm.get('overall.rating')?.invalid"
        >
          <div>Please Select a Rating</div>
        </div>
      </div>
    </form>
  </div>
  <div class="button-wrapper">
    <a class="button trinidad center w-button" (click)="onSubmitReview()"> Continue </a>
  </div>
</div>
